/**
 * pure function that applies a window function to the input data.
 */
export function applyWindow(data, options) {
    const dataLength = data.length;
    const { windowData, start = 0, length = dataLength, pointsToShift = 0, output = new Float64Array(data), } = options;
    const firstEndPoint = Math.min(start + length, dataLength - pointsToShift);
    for (let i = start, j = 0; i < firstEndPoint; i++) {
        output[i] *= windowData[j++];
    }
    for (let i = dataLength - 1, j = 0; i > dataLength - pointsToShift - 1; i--) {
        output[i] *= windowData[j++];
    }
    return output;
}
//# sourceMappingURL=applyWindow.js.map